<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Title ParaOverride-1" id="_idParaDest-5"><span class="CharOverride-7">BOOK ONE<br/>Gone</span></p>
<p class="Normal ParaOverride-1"> </p>
<p class="heading-3 ParaOverride-8"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// When_You_Went_Away-7.vue?a93baea8